const kuaishou = [
    //-------------------快手智借落地页--------------------------------------
    //落地页
    {
      path: '/kuaishou/index.html',
      component: () => import('@/pages/attractTraffic/kuaishouluodiye.vue'),
      meta: {
        title: '智借',
        keepAlive: false
      }
    },
  ]
  export default kuaishou
  


// WEBPACK FOOTER //
// ./src/router/modules/kuaishou.js